import type { DestinationUrlInput } from 'features/campaign/campaign.types';
import { LINK_CONFIG } from './constants';

/**
 * Returns the title of the link value input based on the link type
 *
 * @param linkType - The type of link (asin, browse, deals, manual)
 * @returns The appropriate title for the link value input field or a default value
 */
export const getLinkValueTitle = (linkType: DestinationUrlInput): string => LINK_CONFIG[linkType]?.title ?? 'Link Value';
